import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyCheetahMode({ Copy }: ModeRendererProps) {
  const spots = [] as React.ReactNode[];
  for (let i = 0; i < 80; i++) {
    const x = 40 + (i % 8) * 90;
    const y = 80 + Math.floor(i / 8) * 100;
    spots.push(<rect key={i} x={x} y={y} width={24} height={16} rx={6} fill="#6f3e18" />);
  }
  return (
    <g>
      <rect width={794} height={1123} fill="#f5d19e" />
      {spots}
      <g className="mode-copy" transform="translate(48,840)" fill="#3b2f2b"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyCheetahMode;
